import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { ReportProblem as ReportProblemIcon } from '@mui/icons-material';

import { MenuItem } from 'types/global';

type Props = {
	selected: MenuItem;
	onSelect(event?: React.MouseEvent<HTMLDivElement, MouseEvent>, index?: MenuItem): void;
	open?: boolean;
};

export default function WalletOperations({ selected, onSelect, open }: Props) {
	const { t } = useTranslation();

	return (
		<ListItem
			button
			component={Link}
			to="/wallet/operations"
			selected={selected === MenuItem.WalletOperations}
			onClick={(event: React.MouseEvent<HTMLDivElement, MouseEvent> | any) =>
				onSelect(event, MenuItem.WalletOperations)
			}
		>
			<ListItemIcon>
				<ReportProblemIcon />
			</ListItemIcon>
			{open && <ListItemText primary={t('common:walletOperations')} />}
		</ListItem>
	);
}
